import { message } from "antd";
import K from "./constants";
import history from "./history";
import { GASendEvent } from "features/googleAnalytics/googleAnalytics";

export const handleError = (error, dispatch = null) => {
  console.error(error);
  message.error(error.message);
  return null;
};

export const toCamelCaseToSentence = (string) => {
  return string.replace(/([A-Z]+)*([A-Z][a-z])/g, "$1 $2");
};

export const snakeCaseToSentence = (string) => {
  return string
    ?.split("_")
    ?.map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    ?.join(" ");
};

export const hasOnlyDigits = (string) => {
  return /^-{0,1}\d+$/.test(string);
};

export const getColor = (value) => {
  //value from 0 to 1
  var hue = ((1 - value) * 120).toString(10);
  return ["hsl(", hue, ",65%,70%)"].join("");
};

export const isNumberRegex = () => {
  return new RegExp("^[0-9]*$");
};

export const isDecimalRegex = () => {
  return new RegExp("^\\d+\\.?\\d*$");
};

export const isRolePresent = (roles, userRoles) => {
  let hasRole = true;
  if (roles && roles.length > 0) {
    let roleFound = false;
    for (const routeRole of roles ?? []) {
      if (userRoles.includes(routeRole)) {
        roleFound = true;
        break;
      }
    }
    hasRole = roleFound;
  }
  return hasRole;
};

export const redirectToLogin = (error = "") => {
  if (typeof window !== "undefined") {
    let newUrl =
      window.location.protocol +
      "//" +
      K.Network.URL.Client.BaseHost +
      ":" +
      K.Network.URL.Client.BasePort +
      "/login";
    if (error !== "") {
      newUrl += `?err=${error}`;
    }
    window.location = newUrl;
  }
};

export const redirectToUrl = (path, diaryId, diaryTopicId) => {
  if (diaryId) {
    path += `?diaryId=${diaryId}&diaryTopicId=${diaryTopicId}`;
  }
  window.location.href =
    window.location.protocol +
    "//" +
    K.Network.URL.Client.BaseHost +
    ":" +
    K.Network.URL.Client.BasePort +
    path;
};

export const setFieldErrorsFromServer = (error, form, values = undefined) => {
  if (error?.error === undefined) return;
  const errors = error.message;
  if (typeof errors === "string" || errors instanceof String) {
    message.error(errors);
    return;
  }
  let fieldErrors = [];
  for (let key in errors) {
    if (errors.hasOwnProperty(key)) {
      fieldErrors.push({
        name: key,
        errors: errors[key],
        value: values && values[key] ? values[key] : undefined,
      });
    }
  }
  form.setFields(fieldErrors);
};

export const snakeToCamel = (str) => {
  return str
    ?.toLowerCase()
    .replace(/([-_][a-z])/g, (group) =>
      group.toUpperCase().replace("-", "").replace("_", "")
    );
};

export const camelCaseKeys = (obj) =>
  Object.keys(obj).reduce(
    (ccObj, field) => ({
      ...ccObj,
      [snakeToCamel(field)]: obj[field],
    }),
    {}
  );
export const getAllEntriesParams = (queryParams, diaryTopicId) => {
  queryParams.has("diaryId") && queryParams.delete("diaryId");
  queryParams.set("pageNumber", 1);
  queryParams.set("pageSize", 100);
  queryParams.set("diaryTopicId", diaryTopicId);
  return queryParams.toString();
};
export const DiaryEntryPage = (createSearchParams, data) => {
  // navigate({
  //   pathname: "/",
  const params = createSearchParams({
    diaryId: data,
  }).toString();
  const path = `/?${params}`;
  redirectToUrl(path);
  // window.location.search = params;
  // });
};
export const deleteQueryParam = (key) => {
  const queryParams = new URLSearchParams(window.location.search);
  queryParams.delete(key);
  history.push({
    search: queryParams.toString(),
  });
};
export const convertoUSFormat = (moment, date) => {
  return moment.unix(date).format("MM/DD/YYYY @ hh:mm A");
};
export const convertoUSFormatOnlyDate = (moment, date) => {
  return moment.unix(date).format("MM/DD/YYYY");
};
export const convertoUSFormatOnlyTime = (moment, date) => {
  // return moment.unix(date).format("MM/DD/YYYY");

  return moment.unix(date).format("hh:mm a");
  // return moment.unix(date).format("hh:mm A");
};
export const convertToPlanDate = (moment, date) => {
  return moment.unix(date).utcOffset(0).format("MMM D, YYYY");
};
export const convertToJournalDateFormat = (moment, date) => {
  return moment.unix(date).format("ddd, MMM D, YYYY @ h:mm A");
};
export const diaristName = (data) => {
  return data.users.find((user) => user?.isCreator === true);
};
export const codiaristName = (data) => {
  return data.users.find((user) => user?.isCreator === false);
};

export const getInitials = (first, last) => {
  return first?.charAt(0).toUpperCase() + last?.charAt(0).toUpperCase();
};

export const downloadEvent = (value, name) => {
  const eventOptions = {
    category: "Click",
    action: value,
    label: name ? name : value,
  };
  GASendEvent(eventOptions);
};

export const mobileRegex =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

export const hasOnlySpaces = (text) => {
  const regex = /^(?=.*[a-zA-Z]).*$/g;

  if (regex.test(text)) {
    return false;
  } else {
    return true;
  }
};

export const PersonalityTypesEnum = {
  1: "ISFP",
  2: "ISTJ",
  3: "INTP",
  4: "ENFJ",
  5: "ISFJ",
  6: "INFJ",
  7: "INTJ",
  8: "ISTP",
  9: "INFP",
  10: "ESTP",
  11: "ESFP",
  12: "ENFP",
  13: "ENTP",
  14: "ESTJ",
  15: "ESFJ",
  16: "ENTJ",
};

export const PaymentStatusEnum = {
  active: "Active",
  trialing: "Trial",
  canceled: "Cancel",
  pending_payment: "Pending",
  incomplete: "Expired",
  past_due: "Expired",
  incomplete_expired: "Cancel",
};
export const PaymentStatusColor = {
  active: "green",
  trialing: "orange",
  canceled: "red",
  pending_payment: "yellow",
  incomplete: "red",
  past_due: "red",
  incomplete_expired: "red",
};

export const calculateTimeRemaining = (unixTimestamp, minutes) => {
  const currentTimestamp = Math.floor(Date.now() / 1000); // Current time in UNIX timestamp (seconds)
  const differenceInSeconds = currentTimestamp - unixTimestamp;

  if (differenceInSeconds > 60 * minutes) {
    return null; // If the difference is greater than 1 hour, return null
  }

  const remainingMinutes = Math.floor(
    (60 * minutes - differenceInSeconds) / 60
  );
  const remainingSeconds = (60 * minutes - differenceInSeconds) % 60;

  return { minutes: remainingMinutes, seconds: remainingSeconds };
};

export const DiaryStatusRoutes = {
  1: "/",
  2: "/journal-request",
  3: "/journal-request",
  4: "/journal-request",
  5: "/",
  6: "/",
  7: "/",
};
